// extracted by mini-css-extract-plugin
export default {"item":"permission-form_item__CzS0H"};